// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorInvalidTokenOrBlock_container__U0GLC","text":"ErrorInvalidTokenOrBlock_text__2-BT7"};